__turbopack_context__.v({
  "questionnaireFooter": "QuestionnaireFooter-module__CT-SvW__questionnaireFooter",
});
